<script setup>
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';

import { useI18n } from 'vue-i18n';

const props = defineProps({
  inboxName: {
    type: String,
    default: '',
  },
  inboxIcon: {
    type: String,
    default: '',
  },
  scheduledAt: {
    type: Number,
    default: 0,
  },
});

const { t } = useI18n();

// Türkçe tarih formatı: "13 Ocak Salı, 09:01"
const formatDate = (timestamp) => {
  if (!timestamp) return '';
  // Unix timestamp saniye cinsinden, JavaScript milisaniye bekliyor
  const date = new Date(timestamp * 1000);
  return format(date, 'd MMMM EEEE, HH:mm', { locale: tr });
};
</script>

<template>
  <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
    {{ t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.SENT_FROM') }}
  </span>
  <div class="flex items-center gap-1.5 flex-shrink-0">
    <Icon :icon="inboxIcon" class="flex-shrink-0 text-n-slate-12 size-3" />
    <span class="text-sm font-medium text-n-slate-12">
      {{ inboxName }}
    </span>
  </div>

  <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
    {{ t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.ON') }}
  </span>
  <span class="flex-1 text-sm font-medium truncate text-n-slate-12">
    {{ formatDate(scheduledAt) }}
  </span>
</template>
